import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default function SkeletonLoading({ specificCss = '', count = 1 }) {
  return <Skeleton className={`${specificCss}`} baseColor="#e0e7ff" count={count} />
}
